import {ReactComponent as LinkedInIcon} from './linkedin.svg'

function LinkedIn(props) {
  return <LinkedInIcon {...props} />
}

export default LinkedIn
